import React, { createContext, useMemo, useState } from "react";
export const AdvancedOptionsContext = createContext(null);
export const AdvancedOptionsProvider = ({ children = void 0 }) => {
  const [isAdvancedOptionsVisible, setAdvancedOptionsVisibility] = useState(false);
  const advancedOptionsProvider = useMemo(
    () => ({
      isAdvancedOptionsVisible,
      setAdvancedOptionsVisibility
    }),
    [isAdvancedOptionsVisible, setAdvancedOptionsVisibility]
  );
  return /* @__PURE__ */ React.createElement(AdvancedOptionsContext.Provider, { value: advancedOptionsProvider }, children);
};
